import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'
import { useSubmit } from 'react-router-dom'

export default function MonthlySpendingPage() {
  const submit = useSubmit()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }
  return (
    <TextInputPage
      heading="pages.onboarding.monthlySpending.heading"
      placeholder="pages.onboarding.monthlySpending.placeholder"
      pattern="^\d+(\.\d{1,2})?$"
      onSubmit={handleSubmit}
    />
  )
}
